export default "__VITE_ASSET__DvxCRuAQ__"